import { render } from "./ExecutivesCategory.vue?vue&type=template&id=f8198a1e&scoped=true"
import script from "./ExecutivesCategory.vue?vue&type=script&lang=js"
export * from "./ExecutivesCategory.vue?vue&type=script&lang=js"

import "./ExecutivesCategory.vue?vue&type=style&index=0&id=f8198a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8198a1e"]])

export default __exports__